import { CSSObject } from '@chakra-ui/react';

export const FlexGroupWrapper: CSSObject = {
  mb: '6',
};

export const GroupText: CSSObject = {
  fontSize: 'md',
  color: 'white',
  fontWeight: 'semibold',
};

export const GroupChevron: CSSObject = {
  color: 'white',
  bg: 'linear-gradient(180deg, rgba(70, 78, 139, 0.44) 0%, rgba(70, 78, 139, 0.8) 100%)',
  boxShadow:
    '0px 2px 3px rgba(0, 0, 0, 0.35), inset 0px 0px 3px rgba(255, 255, 255, 0.6), inset 0px 1px 0px rgba(255, 255, 255, 0.3)',
  _hover: {
    bg: 'beta.800',
    boxShadow: 'none',
    color: 'white',
  },
  _focus: {
    boxShadow:
      ' 0px 2px 3px rgba(0, 0, 0, 0.35), inset 0px 0px 3px rgba(255, 255, 255, 0.6), inset 0px 1px 0px rgba(255, 255, 255, 0.3);',
  },
};
